import { lazy } from 'react'

import { urlRoutes } from 'presentation/routes/config/urlRoutes/urlRoutes'

export const AvailableDestinationsRoutes = [
  {
    nameUrl: 'Destinos disponibles',
    path: urlRoutes.private.availableDestinations.url,
    element: lazy(() => import('presentation/pages/availableDestinations')),
    rols: ['*'],
  },
]
